import { Component, OnInit, Inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { ConfigService } from './services/config.service';
import { EnvironmentType } from './enums/environment-type.enum';
import { SessionIdleService } from './services/session-idle.service';
import { MembershipService } from './core/services/membership.service';
import { takeUntil } from 'rxjs/operators';
import { SessionIdleConfigModel } from './models/login.model';
import { Subject, Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'body',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']

})
export class AppComponent implements OnInit {
  public routeData: any;
    private subscription: Subscription;
  private destroy$ = new Subject<void>();
  constructor(private router: Router, private config: ConfigService, private membership_service: MembershipService, @Inject(DOCUMENT) private document, private session_idle_service: SessionIdleService,) {

  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });

    var url: string;
    switch (this.config.getEnvironmentType()) {
      case EnvironmentType.Staging:
        url = "./assets/img/dev_favicon.png"
        break;
      case EnvironmentType.Demo:
        url = "./assets/img/demo_favicon.png"
        break;
      default:
        url = "./assets/img/prod_favicon.png"
        break;
    }

    const link = <HTMLLinkElement>(this.document.head.querySelector("link[rel='icon']")) || this.document.head.appendChild(this.document.createElement('link'));
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = url;

     this.load_session_idle();
  }

    load_session_idle(){

    this.membership_service.token_change$
    .pipe(takeUntil(this.destroy$))
    .subscribe(token=>{
      this.session_idle_service.stop();
       if(token && this.membership_service.isValidToken()){

       this.session_idle_service.GetSessionIdleSettings().subscribe((data: SessionIdleConfigModel)=>{
        if(data.enabled){
          this.session_idle_service.initialize_config(data);
          this.session_idle_service.start();
        } else{
          this.session_idle_service.stop();
        }

      });
       }else{
         this.session_idle_service.stop();
       }
    });

    this.session_idle_service.session_logout$
    .pipe(takeUntil(this.destroy$))
    .subscribe(()=>{
      this.session_idle_service.stop();
      this.membership_service.RedirectToLogin();
    });


  }
    ngOnDestroy(): void {
    // Unsubscribe from the observable to prevent memory leaks
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.destroy$?.next();
    this.destroy$?.complete();
  }
}
